<div class="grid-container margin-top">
    <tabs (tabClicked)="onTabClicked($event)">
        <tab title="Open">
            <ag-grid-angular class="data-grid " [gridOptions]="openGridOptions" [rowData]="openData | async" [excelStyles]="excelStyles" aria-label="Open"></ag-grid-angular>
        </tab>
        <tab title="Closed">
            <ag-grid-angular class="data-grid " [gridOptions]="closedGridOptions" [rowData]="closedData | async" [excelStyles]="excelStyles" aria-label="Closed"></ag-grid-angular>
        </tab>
    </tabs>
</div>